import { useSnapshot } from "valtio";
import { bookingsStore, loginStore } from "../state/CommonState";
import { useEffect, useRef, useState } from "react";
import { AgCustomFile } from "../components/AgFile";
import AgLastUpload from "../components/AgLastUpload";
import BookingsApi from "../state/bookings-api";

export default function InternalV3(props) {
    useSnapshot(bookingsStore);
    const [internalList, setInternalList] = useState({internalremarks:"",supportingDocuments_list:[],updatedOn:"",updatedBy:""});
    const ref = useRef(null);
    const [cursor, setCursor] = useState(0);
    const [isUpdate, setIsUpdate] = useState(false)
    const filecat = '' + Date.now()
    const renderLink = (fileName) => {
        if (fileName && fileName.length > 3) {
            return (
                <a href={process.env.REACT_APP_FILE_SERVER + '/clientfiles/' + fileName} target="_blank">{fileName}</a>
            )
        } else return <></>
    }
    const getv = ()=>{
        return JSON.parse(JSON.stringify(internalList))
    }
    const setBookingStore = (k)=>{
      if(props.autosave!=undefined && props.autosave==true){
        bookingsStore.current.internallist = [k]
      }
    }
    const delFile = (ind)=>{
        let l = []
        let k = getv()
        let a = k.supportingDocuments_list
        for (let i = 0; i < a.length; i++) {
            if(i!=ind){
                l.push(a[i])
            }
        }
        k.supportingDocuments_list = l
        k.updatedOn = Date.now()
        k.updatedBy = loginStore.email
        setInternalList(k)
        setBookingStore(k)
        setIsUpdate(true)
    }
    const handleChange = (e) => {
        setCursor(e.target.selectionStart);
        let k = getv()
        k.internalremarks = e.target.value
        k.updatedOn = Date.now()
        k.updatedBy = loginStore.email
        setInternalList(k)
        setBookingStore(k)
        setIsUpdate(true)
    };
    const addFile = (filename)=>{
        let k = getv()
        k.supportingDocuments_list.push(filename)
        k.updatedOn = Date.now()
        k.updatedBy = loginStore.email
        setInternalList(k)
        setBookingStore(k)
        setIsUpdate(true)
    }
    const save = ()=>{
        let k = []
        if(bookingsStore.current.internallist!=undefined){
            k = JSON.parse(JSON.stringify(bookingsStore.current.internallist))
        }
        k.push(internalList)
        BookingsApi.setInternalList(bookingsStore.current._id,k)
        bookingsStore.current.internallist = k
        setIsUpdate(false)
    }
    useEffect(()=>{
        let k = []
        if(bookingsStore.current.internallist!=undefined){
            k = JSON.parse(JSON.stringify(bookingsStore.current.internallist))
        }
        let b = {internalremarks:"",supportingDocuments_list:[],updatedOn:"",updatedBy:""}
        const jsy = (v) => {return JSON.stringify(v)}
        if(k.length>0){
            let a = k[k.length-1]
            if(jsy(internalList)!=jsy(a) && jsy(internalList)==jsy(b)){
                setInternalList(a)
            }
        }
    },[bookingsStore.current])
  return (
    <>
      <div
        style={{
          backgroundColor: "#fff",
          borderRadius: ".25rem",
          boxShadow:
            "0 .5em 1em -.125em rgba(10, 10, 10, .1), 0 0 0 1px rgba(10, 10, 10, .02)",
          color: "#4a4a4a",
          maxWidth: "100%",
          position: "relative",
          padding: "15px",
        }}
      >
        <div className="columns is-vcentered is-multiline">
          <div className="column is-12">
            <h3 className="title is-5">Internal Remarks</h3>
            <textarea
              ref={ref}
              value={internalList.internalremarks}
              onChange={handleChange}
              class="textarea"
              placeholder=""
            />
          </div>
          <div className="column is-12">
              <table className="table is-fullwidth is-bordered is-striped is-narrow is-hoverable ">
                <thead>
                  <tr>
                    <th style={{ width: "16rem" }}>Required Documents</th>
                    <th>Document Uploaded</th>
                    <th style={{ width: "12rem" }}></th>
                  </tr>
                </thead>
                <tbody>
                  <tr id="cwf5">
                    <td>Supporting Documents</td>
                    <td>
                      {internalList.supportingDocuments_list &&
                        internalList.supportingDocuments_list
                          .map(renderLink)
                          .map((link, i) => (
                            <>
                              <p>
                                {link}
                                <span
                                  className="icon has-text-danger"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    delFile(
                                        i
                                      );
                                  }}
                                >
                                  <i className="fas fa-trash"></i>
                                </span>
                              </p>
                              <br />
                            </>
                          ))}
                    </td>
                    <td>
                      <AgCustomFile
                        source="carrierwebform"
                        cat={filecat}
                        filetype="supportingDocuments"
                        parent="cwf5"
                        multi={true}
                        callback={(filename) => {
                            addFile(filename)
                        }}
                        withBtn={
                          internalList.supportingDocuments_list &&
                          internalList.supportingDocuments_list.length > 0
                        }
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            
          </div>
          {
            (props.autosave!=undefined && props.autosave==false)?<>
          <div className={`column ${isUpdate?"is-10":"is-12"}`}>
            {internalList.updatedBy.length>0 && <AgLastUpload data={internalList} />}</div>
          {isUpdate && <div className="column is-2">
            <p className="control" >
          <button className="button" style={{textAlign:"right", backgroundColor: process.env.REACT_APP_ENTERPRISE_COLOUR_BUTTON, color: "#fff", }}
          onClick={(e) => {
            save()
         }}>save
     </button></p>
          </div>}
            </>:""
          }
        </div>
      </div>
    </>
  );
}
